import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import type { TypographyVariant } from '@sorare/core/src/atoms/typography';
import { BrandXXS, HeadlineL } from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';
import type { Color } from '@sorare/core/src/style/types';

const StyledSpan = styled.span`
  display: inline-flex;
  gap: 2px;
  align-items: start;
  font-family: var(--brand-font);
`;
const Exponent = styled(BrandXXS)`
  margin-top: var(--half-unit);
`;

type Props = {
  score: number | null;
  roundingScore?: boolean;
  Typography?: TypographyVariant;
  exponentColor?: Color;
};

export const ContenderScore = ({
  score,
  roundingScore = true,
  Typography = HeadlineL,
  exponentColor = 'var(--c-nd-600)',
}: Props) => {
  const scoreToDisplay = roundingScore
    ? Math.floor(score || 0)
    : score?.toFixed(2);

  return (
    <Typography>
      <StyledSpan>
        <FormattedMessage
          {...fantasy.ordinalPoints}
          values={{
            score: typeof score === 'number' ? scoreToDisplay : '-',
            sup: c => <Exponent color={exponentColor}>{c}</Exponent>,
          }}
        />
      </StyledSpan>
    </Typography>
  );
};
